import { render, staticRenderFns } from "./certs-pie.vue?vue&type=template&id=12b095ea&scoped=true&"
import script from "./certs-pie.vue?vue&type=script&lang=js&"
export * from "./certs-pie.vue?vue&type=script&lang=js&"
import style0 from "./certs-pie.vue?vue&type=style&index=0&id=12b095ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b095ea",
  null
  
)

export default component.exports